import React, { Fragment, useEffect, useState } from 'react';

import moment from 'moment';
import {
  RideGlUserCheckSolid, RideGrid,
} from '@rimac-seguros/ride-system-components';

import { useAppContext } from '../../../AppProvider';
import { calculateAge } from '../../../utils/helpers';
// import { getTagActionName } from '../../../utils/analytics';

import './styles.scss';

const BannerQuoteInsured = () => {
  const { state: { client }, dispatch } = useAppContext();
  const birthDate = moment(client.fechaNacimiento, 'YYYY-MM-DD').toDate();
  const birthDateFormatLocal = moment(birthDate).format('DD/MM/YYYY');

  const [open] = useState(false);
  const [insureds] = useState([
    {
      title: 'Titular',
      subtitle: `F. nacimiento: ${birthDateFormatLocal}`,
      name: `${client.nombres} ${client.apellidoPaterno} ${client.apellidoMaterno}`,
      action: false,
      dateInsured: birthDateFormatLocal,
      age: calculateAge(client.fechaNacimiento),
      relationship: 0,
      phone: client.telefono,
    },
  ]);

  useEffect(() => {
    dispatch({ type: 'SAVE_INSURED_LIST', payload: insureds });
  }, [insureds]);

  // const handleAddInsured = () => {
  //   getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Planes', 'Agregar dependiente', 'trackAction');
  // };

  // const handleOpenCollapse = () => {
  //   const auxOpen = !open;
  //   setOpen(auxOpen);
  //   if (auxOpen) {
  //     getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Planes', 'Ver resumen', 'trackAction');
  //   }
  // };

  return (
    <section className="banner-qi">
      <RideGrid>
        <div className="banner-qi_content">
          <div className={`banner-qi_content-collapse ${open ? 'open' : ''}`}>
            <div className="banner-qi_content-collapse--head">
              <div>
                <RideGlUserCheckSolid size="x-large" />
                <span>Cotización para: {insureds.length} asegurado{insureds.length > 1 && 's'}</span>
                {/* <RideButton
                  text="Agregar dependiente"
                  variant="text-primary"
                  size="medium"
                  glyph="RideGlAddSolid"
                  glyphPosition="left"
                  className="banner-qi_content-collapse--head-btn-add"
                  onClick={handleAddInsured}
                /> */}
              </div>
              <div>
                {/* <RideIconButton glyph={<RideGlDown />} size="small" variant="outline" onClick={() => setOpen(!open)} /> */}
              </div>
            </div>
            <div className="banner-qi_content-collapse--body">
              <div>
                {insureds.length > 1 && insureds.map((_, i) => (
                  <Fragment key={`insured-${i}`}>
                    <div className="banner-qi_content-collapse--body-item">
                      <p className="banner-qi_content-collapse--body-item-name">Titular: {_.name}</p>
                      <p className="banner-qi_content-collapse--body-item-age">Edad: {_.age} años</p>
                    </div>
                    {i + 1 < insureds.length && <div className="banner-qi_content-collapse--body-line" />}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          {/* <RideButton
            text="Agregar dependiente"
            variant="text-primary"
            size="medium"
            glyph="RideGlAddSolid"
            glyphPosition="left"
            className="banner-qi_content-btn"
            onClick={handleAddInsured}
          /> */}
          {/* <RideButton
            text={open ? 'Ocultar resumen' : 'Ver resumen'}
            variant="text-secondary"
            size="large"
            glyph="RideGlUp"
            glyphPosition="right"
            className={`banner-qi_content-btn-show ${open ? 'open' : ''}`}
            onClick={handleOpenCollapse}
          /> */}
        </div>
      </RideGrid>
    </section>
  );
};

export default BannerQuoteInsured;
